import { HttpResponse } from '@angular/common/http';

import { TaggedEntity } from './models';

export function extendWithEntityTag<T>(
  response: HttpResponse<T>,
): T & TaggedEntity {
  return {
    ...(response.body as T),
    etag: response.headers.get('etag'),
  };
}
